import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { FaEdit, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import { deleteMandal } from "../../redux/district/districtSlice";
import "./MandalsTable.css"; // Import CSS file

const MandalsTable = ({ setEditId, mandals }) => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Filter mandals based on search input
  const filteredMandals = mandals.filter((mandal) => {
    const mandalName = mandal.mandal.english.toLowerCase();
    return mandalName.includes(searchTerm.toLowerCase());
  });

  // Calculate pagination indexes
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentMandals = filteredMandals.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const nextPage = () => {
    if (indexOfLastItem < filteredMandals.length) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleDelete = (slugUrl) => {
    toast.warn(
      <div>
        <p>Are you sure you want to delete this mandal?</p>
        <div className="toast-buttons">
          <button
            onClick={() => {
              toast.dismiss("delete-toast");
              dispatch(deleteMandal(slugUrl));
            }}
            className="yes-btn"
          >
            Yes
          </button>
          <button
            onClick={() => toast.dismiss("delete-toast")}
            className="no-btn"
          >
            No
          </button>
        </div>
      </div>,
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        pauseOnHover: true,
        closeButton: false,
        toastId: "delete-toast",
      }
    );
  };

  return (
    <div className="table-container">
      <input
        type="text"
        placeholder="Search mandal"
        className="search-input"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <div className="table-wrapper">
        <table className="mandals-table">
          <thead>
            <tr>
              <th>No</th>
              <th>State</th>
              <th>District</th>
              <th>Mandal</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentMandals.length > 0 ? (
              currentMandals.map((mandal, index) => (
                <tr key={mandal._id}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>{mandal.state.english} ({mandal.state.telugu})</td>
                  <td>{mandal.districts.english} ({mandal.districts.telugu})</td>
                  <td>{mandal.mandal.english} ({mandal.mandal.telugu})</td>
                  <td className="actions">
                    <FaEdit onClick={() => setEditId(mandal._id)} className="edit-icon" />
                    <FaTrash onClick={() => handleDelete(mandal._id)} className="delete-icon" />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="no-data">No mandals found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="pagination">
        <button onClick={prevPage} disabled={currentPage === 1} className="page-btn">
          Previous
        </button>
        <span>Page {currentPage}</span>
        <button onClick={nextPage} disabled={indexOfLastItem >= filteredMandals.length} className="page-btn">
          Next
        </button>
      </div>
    </div>
  );
};

export default MandalsTable;
